export default __webpack_public_path__ + "static/media/shareholders.15f8d72a.svg";